exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".no-results__container___2SASS{padding:60px 0 80px;border:1px solid #e9e9e9;text-align:center;color:#888}.no-results__container___2SASS h2{text-align:center;color:#888}", ""]);

// exports
exports.locals = {
	"container": "no-results__container___2SASS"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/no-results.scss
// module id = 1069
// module chunks = 0